module.exports = __webpack_public_path__ + "img/jtbj.d52ec196.png";